<script>
    import { faCircleQuestion, faInfo, faInfoCircle, faQuestion, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";
</script>

<div class="help">
    <Fa
        class="icon"
        icon={faQuestionCircle}
    />
    <span class="tooltiptext">
        <slot></slot>
    </span>
</div>

<style>
    /* Tooltip container */
    .help {
        z-index: 0;
        position: relative;
        display: inline-block;
        margin-inline-start: 0.5rem;
        margin-inline-end: 0.5rem;
        color: #E0D8D2;
    }

    .help:hover {
        z-index: 100;
    }

    /* help text */
    .help .tooltiptext {
        z-index: 1000;
        visibility: hidden;
        width: 10rem;
        background-color: hsl(0 0% 20%);
        color: white;
        text-align: left;
        padding: 0.5rem 0.8rem;
        font-size: 0.8rem;
        border-radius: 0.5rem;

        /* Position the tooltip text */
        position: absolute;
        z-index: 1;
        top: 125%;
        left: 50%;
        margin-left: -60px;

        /* Fade in tooltip */
        opacity: 0;
        transition: opacity 0.3s;
    }

    /* Tooltip arrow */
    .help .tooltiptext::after {
        content: "";
        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent hsl(0 0% 20%) transparent;
    }

    /* Show the tooltip text when you mouse over the tooltip container */
    .help:hover .tooltiptext {
        z-index: 2;
        visibility: visible;
        opacity: 1;
    }
</style>